import React from 'react';
export default function MenuItem(props) {
    var item = props.item, sections = props.sections, indexSec = props.indexSec, isFlyoverSite = props.isFlyoverSite;
    var getArrayTypes = function () {
        var groupArray = [];
        groupArray.push(item);
        for (var i = indexSec + 1; i < sections.length; i++) {
            if (sections[i].stripClassName == "sky23.menuitem") {
                groupArray.push(sections[i]);
            }
            else {
                break;
            }
        }
        return groupArray;
    };
    var groupByType = getArrayTypes();
    return (React.createElement("div", { className: "row mb-5 row-menu-grid"
            + (isFlyoverSite ? "" : " text-primary") }, groupByType && groupByType.length > 0 && groupByType.map(function (itemMenu, p) {
        return (React.createElement("div", { className: "col menu-item d-flex orientation-"
                + (itemMenu.fields.orientation ? itemMenu.fields.orientation : "center")
                + (itemMenu.fields.orientation == "letf" ? " w-100" : ""), itemProp: "hasMenuItem", itemScope: true, itemType: "https://schema.org/MenuItem" },
            React.createElement("div", { className: "menu-item-body"
                    + (itemMenu.fields.orientation == "left" ? " flex-grow-1" : "") },
                itemMenu.fields.displayTitle && React.createElement("div", { className: "h4 font2 mb-3", itemProp: "name" }, itemMenu.fields.displayTitle) || null,
                itemMenu.fields.content && React.createElement("p", { className: "fs-sm" },
                    React.createElement("div", { className: "strip-content", dangerouslySetInnerHTML: { __html: itemMenu.fields.content }, itemProp: "description" })) || null,
                itemMenu.fields.dietaryTags && React.createElement("p", { className: "fs-sm", itemProp: "description" }, itemMenu.fields.dietaryTags) || null),
            React.createElement("div", { className: "menu-item-footer", itemProp: "offers", itemScope: true, itemType: "https://schema.org/Offer" },
                React.createElement("p", { className: "price ", itemProp: "price" }, itemMenu.fields.price))));
    })));
}
